'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { useEffect, useState } from 'react'

export function RegisterProgressBar({ seconds }: { seconds: number }) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((value) => (value >= 100 ? 100 : value + 1 / seconds))
    }, 10)

    return () => clearInterval(timer)
  }, [seconds])

  return (
    <div className="space-y-3">
      <div className="h-2 overflow-hidden rounded-full bg-mist-950/10 dark:bg-white/20">
        <div style={{ width: `${progress}%` }} className="h-full bg-mist-950 dark:bg-white" />
      </div>
      <p className="text-xs font-semibold text-mist-500 dark:text-white/70">{`${Math.round(progress)}%`}</p>
    </div>
  )
}
